import { useTranslation } from 'react-i18next';
import type { ThemeDirection } from '@/theme';

const RTL_LANGUAGES = new Set(['ar']);

export function useLocale() {
  const { i18n } = useTranslation();
  const direction: ThemeDirection = RTL_LANGUAGES.has(i18n.language) ? 'rtl' : 'ltr';

  return {
    language: i18n.language,
    direction,
    changeLanguage: (lang: string) => i18n.changeLanguage(lang),
  };
}
